import { useCallback, useState } from 'react'
import { useIntl } from 'react-intl'
import { makePublicUrl } from 'app/utils/publicUrl'
import { purchaseSubscriptionMessages } from './messages'
import {
  PurchaseSubscriptionBlock,
  PurchaseSubscriptionBlockWrapper,
  PurchaseSubscriptionContentBlock,
  PurchaseSubscriptionHeader,
  PurchaseSubscriptionHeaderLinkButton,
  PurchaseSubscriptionHeaderTitle,
  PurchaseSubscritpionBlockItem,
  PurchaseSubscritpionItemSubtitle,
  PurchaseSubscritpionItemTitle,
  StyledPurchaseItemImg,
  SubscriptionInfoStyledManageButton,
  SubscriptionInfoStyledCancelButton,
  PurchaseSubscriptionFooterBlock,
} from '../PurchaseDeviceTotal/styles'
import { formatPrice } from 'features/home/components/HomeSubscription/utils'
import CancelNetworkModal from './CancelNetworkModal'
import { generatePath, useHistory } from 'react-router-dom'
import ROUTES from 'app/routes'
import { hasSubscriptionPermissionSelector } from 'features/auth/permissions/selectors'
import { useAppSelector } from 'app/hooks'

export interface SmartNetworkSubsProps {
  apQuantity: number
  renewQuantity: number
  amount: number
  homeId: string
  renewalDate: number
  rootDomainId: string
  priceId: string
  paymentMethodId: string
  subscriptionState: string
}

const SmartNetworkSubs = (props: SmartNetworkSubsProps) => {
  const {
    apQuantity,
    renewQuantity,
    amount,
    homeId,
    renewalDate,
    rootDomainId,
    priceId,
    paymentMethodId,
    subscriptionState,
  } = props
  const { formatMessage } = useIntl()
  const history = useHistory()
  const hasSubscriptionPermission = useAppSelector(
    hasSubscriptionPermissionSelector
  )

  const [subsCancelOpen, setSubsCancelOpen] = useState(false)

  const handleCancelSubscription = () => {
    setSubsCancelOpen(true)
  }

  const handleNavigateNetworkAIClick = useCallback(() => {
    const path = generatePath(ROUTES.networkAi.dashboard.rootNoJob, {
      rootDomainId,
      homeId,
    })
    history.push(path)
  }, [history, homeId, rootDomainId])

  return (
    <>
      {subsCancelOpen && (
        <CancelNetworkModal
          onClose={() => setSubsCancelOpen(false)}
          homeId={homeId}
          periodEnd={renewalDate}
          priceId={priceId}
          paymentMethodId={paymentMethodId}
        />
      )}
      <PurchaseSubscriptionBlock>
        <PurchaseSubscriptionHeader>
          <PurchaseSubscriptionHeaderTitle>
            {formatMessage(
              purchaseSubscriptionMessages.networkAISubscriptionLabel
            )}
          </PurchaseSubscriptionHeaderTitle>
          <PurchaseSubscriptionHeaderLinkButton></PurchaseSubscriptionHeaderLinkButton>
        </PurchaseSubscriptionHeader>
        <PurchaseSubscriptionContentBlock>
          <PurchaseSubscriptionBlockWrapper disabled={false}>
            <PurchaseSubscritpionBlockItem>
              <PurchaseSubscritpionItemTitle>
                {formatMessage(purchaseSubscriptionMessages.accessPointsLabel)}
              </PurchaseSubscritpionItemTitle>
            </PurchaseSubscritpionBlockItem>
            <PurchaseSubscritpionBlockItem>
              <StyledPurchaseItemImg
                src={makePublicUrl(`images/networkIcons/access-points.svg`)}
              />
              Active: {apQuantity} <br />
              Renewing:{' '}
              {subscriptionState !== 'WILL_NOT_RENEW' ? renewQuantity : 0}
            </PurchaseSubscritpionBlockItem>
            <PurchaseSubscritpionBlockItem>
              <PurchaseSubscritpionItemTitle>
                {formatPrice(
                  subscriptionState !== 'WILL_NOT_RENEW'
                    ? amount * renewQuantity
                    : 0
                )}
                /y
              </PurchaseSubscritpionItemTitle>
            </PurchaseSubscritpionBlockItem>
          </PurchaseSubscriptionBlockWrapper>
          <PurchaseSubscriptionBlockWrapper disabled>
            <PurchaseSubscritpionBlockItem>
              <PurchaseSubscritpionItemTitle>
                {formatMessage(purchaseSubscriptionMessages.switchesLabel)}
              </PurchaseSubscritpionItemTitle>
            </PurchaseSubscritpionBlockItem>
            <PurchaseSubscritpionBlockItem>
              <StyledPurchaseItemImg
                src={makePublicUrl(`images/networkIcons/switches.svg`)}
              />
            </PurchaseSubscritpionBlockItem>
            <PurchaseSubscritpionBlockItem>
              <PurchaseSubscritpionItemSubtitle>
                {formatMessage(purchaseSubscriptionMessages.comingSoonLabel)}
              </PurchaseSubscritpionItemSubtitle>
            </PurchaseSubscritpionBlockItem>
          </PurchaseSubscriptionBlockWrapper>
          <PurchaseSubscriptionBlockWrapper disabled>
            <PurchaseSubscritpionBlockItem>
              <PurchaseSubscritpionItemTitle>
                {formatMessage(purchaseSubscriptionMessages.wanEdgesLabel)}
              </PurchaseSubscritpionItemTitle>
            </PurchaseSubscritpionBlockItem>
            <PurchaseSubscritpionBlockItem>
              <StyledPurchaseItemImg
                src={makePublicUrl(`images/networkIcons/wan-edges.svg`)}
              />
            </PurchaseSubscritpionBlockItem>
            <PurchaseSubscritpionBlockItem>
              <PurchaseSubscritpionItemSubtitle>
                {formatMessage(purchaseSubscriptionMessages.comingSoonLabel)}
              </PurchaseSubscritpionItemSubtitle>
            </PurchaseSubscritpionBlockItem>
          </PurchaseSubscriptionBlockWrapper>
        </PurchaseSubscriptionContentBlock>
        <PurchaseSubscriptionFooterBlock>
          <SubscriptionInfoStyledManageButton
            type="button"
            variant={'secondary'}
            onClick={handleNavigateNetworkAIClick}
            disabled={!hasSubscriptionPermission}
          >
            {formatMessage(purchaseSubscriptionMessages.manage)}
          </SubscriptionInfoStyledManageButton>
          {renewQuantity !== 0 &&
            subscriptionState !== 'EXPIRES' &&
            subscriptionState !== 'WILL_NOT_RENEW' && (
              <SubscriptionInfoStyledCancelButton
                type="button"
                variant={'secondary'}
                onClick={handleCancelSubscription}
                disabled={!hasSubscriptionPermission}
              >
                {formatMessage(purchaseSubscriptionMessages.cancelRenewal)}
              </SubscriptionInfoStyledCancelButton>
            )}
        </PurchaseSubscriptionFooterBlock>
      </PurchaseSubscriptionBlock>
    </>
  )
}

export default SmartNetworkSubs
